import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'confirm-email',
        path: `${AUTH_PREFIX_PATH}/confirm-email`,
        component: React.lazy(() => import('views/auth-views/authentication/confirm-email')),
    },
    {
        key: 'rsvp',
        path: `/rsvp`,
        component: React.lazy(() => import('views/auth-views/rsvp')),
    },
    {
        key: 'confirmacao-presenca-legacy',
        path: `/confirmacao-presenca`,
        component: React.lazy(() => import('views/auth-views/rsvp')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'matches',
        path: `${APP_PREFIX_PATH}/matches`,
        component: React.lazy(() => import('views/app-views/matches')),
    },
    {
        key: 'matches-add',
        path: `${APP_PREFIX_PATH}/matches/add-match`,
        component: React.lazy(() => import('views/app-views/matches/add-match')),
    },
    {
        key: 'matches-edit',
        path: `${APP_PREFIX_PATH}/matches/edit-match/:id`,
        component: React.lazy(() => import('views/app-views/matches/edit-match')),
    },
    {
        key: 'my-wallet',
        path: `${APP_PREFIX_PATH}/my-wallet`,
        component: React.lazy(() => import('views/app-views/wallet')),
    },
    {
        key: 'convidados',
        path: `${APP_PREFIX_PATH}/convidados`,
        component: React.lazy(() => import('views/app-views/convidados')),
    },
    {
        key: 'check-in',
        path: `${APP_PREFIX_PATH}/check-in`,
        component: React.lazy(() => import('views/app-views/check-in')),
    },
    {
        key: 'confirmacao-presenca-legacy',
        path: `${APP_PREFIX_PATH}/confirmacao-presenca`,
        component: React.lazy(() => import('views/app-views/check-in')),
    },
    {
        key: 'alterar-senha',
        path: '/app/alterar-senha',
        component: React.lazy(() => import('views/app-views/alterar-senha')),
    },
    {
        key: 'orcamento',
        path: `${APP_PREFIX_PATH}/orcamento`,
        component: React.lazy(() => import('views/app-views/orcamento')),
    },
    {
        key: 'tarefas',
        path: `${APP_PREFIX_PATH}/tarefas`,
        component: React.lazy(() => import('views/app-views/tarefas')),
    },
    {
        key: 'templates',
        path: `${APP_PREFIX_PATH}/templates`,
        component: React.lazy(() => import('views/app-views/templates')),
    },
    {
        key: 'staff',
        path: `${APP_PREFIX_PATH}/staff`,
        component: React.lazy(() => import('views/app-views/staff')),
    },
    {
        key: 'staff-dashboard',
        path: `${APP_PREFIX_PATH}/staff-dashboard`,
        component: React.lazy(() => import('views/app-views/staff/staff-dashboard')),
    },
]